import typo from '../../../atoms/flightBriefPdf/flightBriefTypography.module.css';
import styles from './BriefSection.module.css';

/**
 * Bordered card wrapper shared by every flight brief section.
 *
 * The `title` slot is optional and rendered above the content, so a section
 * can be untitled, titled, or carry a fully custom heading through composition.
 * `variant` only switches the visual theme (light card vs dark band).
 * @param {object} props
 * @param {React.ReactNode} [props.title] - Optional heading slot.
 * @param {'start' | 'center'} [props.titleAlign] - Heading alignment.
 * @param {'default' | 'dark'} [props.variant] - Visual theme of the card.
 * @param {'default' | 'sm'} [props.titleSize] - Heading size variant.
 * @param {React.ReactNode} props.children - Section content.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function BriefSection({
  title = null,
  titleAlign = 'start',
  variant = 'default',
  titleSize = 'default',
  children,
  className = '',
}) {
  const titleTypo = titleSize === 'sm' ? typo['section-title-sm'] : typo['section-title'];

  return (
    <section className={`${styles.section} ${styles[variant]} ${className}`}>
      {title ? (
        <div className={`${styles.title} ${styles[`title-${titleAlign}`]} ${titleTypo}`}>{title}</div>
      ) : null}
      {children}
    </section>
  );
}

export default BriefSection;
